document.querySelectorAll('.f-product-single__title, .product-card__title').forEach(el => {
  const text = el.textContent.trim();
  const updatedHTML = text.replace(/\b(Women's|Men's)\b/, '<span style="display:none;">$1</span>');
  el.innerHTML = updatedHTML;
});

  function applyOverlayToMedia0() {
    const media0Elements = document.querySelectorAll('[data-media-index="0"]');
    media0Elements.forEach(el => {
      if (!el.classList.contains('sloggers-overlay')) {
        el.classList.add('sloggers-overlay');
      }
    });
  }